import React from 'react';
import PullToRefresh from '../common/PullToRefresh';
import { useRefresh } from '../../hooks/useRefresh';

const MainPageLayout = ({ children, className = "" }) => {
  const { refreshData } = useRefresh();

  return (
    <div className={`h-full overflow-hidden ${className}`}>
      <PullToRefresh onRefresh={refreshData}>
        <div className="px-4 py-5 min-h-full">
          {children}
        </div>
      </PullToRefresh>
    </div>
  );
};

export default MainPageLayout;